export  const generateReadableError=(e)=>{
    let readableError = (e.response && e.response.data && e.response.data.message)?e.response.data.message:
    (e.response && e.response.data && e.response.data.error && e.response.data.error.message)?e.response.data.error.message:null
    return (readableError)?readableError:(e.response && e.response.status && e.response.status===401)?'You are not authorized to perform this action':'Server Error';
}